import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import { getIconColour } from '../../../../helpers/app';
import ServerIcon from '../../../../assets/icons/server';
import CrmSection from './CrmSection';
import { DSButton } from '../../../../components/Button/Button';
import { dataAttributesState } from '../../../ProjectDetails/Sections/helper';

type PropsType = {
  onDownload: () => void;
  hasPermissionsForm?: boolean;
};

const CrmDataAttributes: React.FC<PropsType> = ({ onDownload, hasPermissionsForm = false }) => {
  const type = dataAttributesState(hasPermissionsForm);
  const theme = useTheme();

  return (
    <CrmSection
      icon={<ServerIcon stroke={getIconColour(type, theme)} />}
      title="Data Attributes"
      description="Cross-matched data fields naming, purpose, and permissions. "
      type={type}
    >
      <DSButton onClick={onDownload} disabled={!hasPermissionsForm}>
        Download Form
      </DSButton>
    </CrmSection>
  );
};

export default CrmDataAttributes;
